const API_BASE = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

type AuthFetchOptions = RequestInit & {
  token?: string | null;
  json?: boolean;
};

const AUTH_TOKEN_KEY = "auth_token";
const AUTH_USER_KEY = "auth_user";
const LEGACY_KEYS = ["user", "username", "rol"];

export function api(path: string) {
  return `${API_BASE}${path}`;
}

function clearAuthStorage() {
  try {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(AUTH_USER_KEY);

    for (const key of LEGACY_KEYS) {
      localStorage.removeItem(key);
    }
  } catch (error) {
    console.error("No se pudo limpiar auth en localStorage", error);
  }
}

function redirectToLogin() {
  if (window.location.pathname !== "/") {
    window.location.replace("/");
  }
}

export async function authFetch(path: string, options: AuthFetchOptions = {}) {
  const { token, json = false, headers, ...rest } = options;

  const normalizedHeaders = new Headers(headers || {});

  if (json && !normalizedHeaders.has("Content-Type")) {
    normalizedHeaders.set("Content-Type", "application/json");
  }

  if (token) {
    normalizedHeaders.set("Authorization", `Bearer ${token}`);
  }

  const response = await fetch(api(path), {
    ...rest,
    headers: normalizedHeaders,
  });

  // RAÍZ del bug reportado en el Sprint Operativo (login de Coordinador que
  // "autentica y vuelve al inicio"): 401 (sin token / token inválido) y 403
  // (autenticado, pero sin la capacidad/perfil que esa ruta exige) NO son lo
  // mismo. Antes de este perfil, prácticamente el único ADMIN real tenía
  // todas las capacidades, así que un 403 nunca ocurría en la práctica —
  // con Picker/Coordinador/Liquidaciones (capacidades intencionalmente
  // acotadas), un 403 es una respuesta NORMAL y frecuente, no una sesión
  // inválida. Deslogueaba y recargaba duro (window.location.replace) ante
  // CUALQUIER 403 — el primer fetch sin el permiso justo (ej. GET
  // /v1/data/admin, que exige db_access, disparado desde la home apenas
  // loguea) tiraba al usuario de vuelta al login en loop. Otras pantallas
  // (HomeDriver.tsx, DriverDeliveries.tsx, ManualLoad.tsx) ya distinguían
  // 401 de 403 a mano — acá se corrige en la única función central que
  // usa todo lo demás (Liquidaciones, Reportes Operativos, Users, etc.),
  // en vez de repetir el distingo en cada pantalla nueva.
  if (response.status === 401) {
    clearAuthStorage();
    redirectToLogin();
  }

  return response;
}